import styled from 'styled-components'

export const ContainerFluidWrapper = styled.div`
  margin: 0 auto;
  padding: 0px 20px;
`
